module.exports = __webpack_public_path__ + "img/wxMini.9604e674.png";